export default {
  assets: [],
  folders: [],
  categories: [],
  storage: [],
  uploadFolders: [],
};
